import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Provincia } from '../_models/provincia.model';

@Injectable({
  providedIn: 'root',
})
// Este servicio carga las provincias al iniciar la aplicación, no se ha de usar el método cargarProvincias
export class ProvinciaService {
  private http = inject(HttpClient);

  private apiUrl = `${environment.apiUrl}/Provincia`;

  private _provincias: Provincia[] = [];

  constructor() {}

  get provincias(): Provincia[] {
    return this._provincias;
  }

  // No usar fuera del APP_INITIALIZER
  public cargarProvincias() {
    return this.http.get<Provincia[]>(`${this.apiUrl}/lista`).pipe(
      tap((provincias) => {
        this._provincias = provincias;
      }),
    );
  }
}
